import { differenceInCalendarDays } from 'date-fns';
import { CheckOutline } from '@aslanpay/portal-common-lib';

import { ReactNode } from 'react';

import { ApprovalsTab, ESCALATION_DAYS_THRESHOLD, RecognitionWithPot } from './Approvals.types';

export const ApprovalsTabEmptyPage: {
  [key in ApprovalsTab]: {
    title: string;
    description: string;
    icon: ReactNode;
  };
} = {
  escalations: {
    title: 'All caught up!',
    description: 'No escalated recognitions requiring your action',
    icon: <CheckOutline color="brand.purple" boxSize="40px" />,
  },
  pendingApprovals: {
    title: 'All caught up!',
    description: 'No recognitions requiring your action',
    icon: <CheckOutline color="brand.purple" boxSize="40px" />,
  },
};

function getEscalations(
  list: RecognitionWithPot[],
  escalationDaysThreshold = ESCALATION_DAYS_THRESHOLD
): RecognitionWithPot[] {
  const today = new Date();

  return list.filter(({ submittedAt }) => {
    return differenceInCalendarDays(today, new Date(submittedAt)) >= escalationDaysThreshold;
  });
}

export default getEscalations;
